import { IonContent } from '@ionic/react';
import React from 'react';

import { PaymentModal } from '@/modals/Payment';
import { webCampaign } from '@/modules/webCampaign';
import { FixedTimer } from '@/pages/Paywall/components/FixedTimer';
import { PaywallAINumber } from '@/pages/Paywall/sections/AINumber';
import { PaywallGuaranteePeriod } from '@/pages/Paywall/sections/GuaranteePeriod';

import { SectionPaymentMethodSelection } from '../../sections/PaymentMethodSelection';

import { PaywallV5Styles } from './FastPayTabsDominant.styles';
import { SectionHowItWorks } from './sections/HowItWorks';
import { SectionMainImage } from './sections/MainImage';
import { SectionSelectPlan } from './sections/SelectPlan';
import { SectionPaywallUsersReviews } from './sections/UsersReviews';

const FastPayTabsDominant: React.FC = () => {
  const showFixedTimer = webCampaign.setup.paywallNotes.includes('fixed-timer');

  return (
    <PaywallV5Styles hasTimer={showFixedTimer}>
      {showFixedTimer && <FixedTimer />}

      <IonContent>
        <SectionMainImage />

        <SectionSelectPlan />

        <PaywallAINumber />

        <SectionPaywallUsersReviews />

        <SectionHowItWorks theme={'domination'} />

        <SectionPaymentMethodSelection theme={'domination'} />

        <PaywallGuaranteePeriod theme={'domination'} />
      </IonContent>

      <PaymentModal />
    </PaywallV5Styles>
  );
};

export default FastPayTabsDominant;
